import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { COMPANY_NAME } from "../../utils/apiConfig";

const Navbar = () => {
  const [isNavScrolled, setIsNavScrolled] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const handleMenu = () =>{
    if(showMenu){
      setShowMenu(false);
    }else{
      setShowMenu(true);
    }
    
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsNavScrolled(true);
      }
      else {
        setIsNavScrolled(false);
      }
    }


    window.addEventListener("scroll", handleScroll);

  // Clean up the event on component unmount
  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
  }, []);

  return (
    <div className={isNavScrolled ? "navMain navFixed" : "navMain"} id="navMain">
      <nav className="nav-bar">

        <div className="logo">
          <Link to={'/'}>{ COMPANY_NAME }</Link>
          {/* <a href="#">Hareharan</a> */}
        </div>
        <ul className={showMenu ? "menuLinks show-menu" : "menuLinks" }  id="menuLinks">
          <li><Link to={'/'} onClick={() => setShowMenu(false)}>Home</Link></li>
          <li><Link to={'/about'} onClick={() => setShowMenu(false)}>About</Link></li>
          <li><Link to={'/services'} onClick={() => setShowMenu(false)}>Services</Link></li>
          <li><Link to={'/projects'} onClick={() => setShowMenu(false)}>Projects</Link></li>
          <li><Link to={'/contact'} onClick={() => setShowMenu(false)}>Contact</Link></li>
        </ul>
        <div onClick={handleMenu} className={showMenu ? "burger show-icon" : "burger" } id="nav-toggle">
          <div className="line line1"></div>
          <div className="line line2"></div>
          {/* <div className="line line3"></div> */}


          {/* <!-- <i className="fa-solid fa-grip-lines"></i> --> <!-- For no-transition icon --> */}
        </div>
      </nav>
    </div>
  )
}

export default Navbar